import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useMobile } from 'shared/utils/hooks/useMobile';

import GroupChannelListHeader from '@sendbird/uikit-react/GroupChannelList/components/GroupChannelListHeader';

import { GroupChannelList } from '@sendbird/uikit-react/GroupChannelList';
import {
  getPatientConversationChannelsSelector,
  getUnreadCount,
  setChannel
} from 'store/patientConversation/patientConversation.redux';
import { GroupChannelListItem } from '@sendbird/uikit-react/GroupChannelList/components/GroupChannelListItem';
import { classNames } from 'shared/utils/class-names';
import { channelTypeMapping } from 'shared/constants/channel';
import { getAppConfigSelector } from 'store/app/app.redux';
import { getUserSelector } from 'store/user/user.redux';
import {
  CURRENT_AFFILIATE,
  getItemFromLocalStorage
} from 'shared/utils/local-storage';

const Submenu: React.FC = () => {
  const isMobile = useMobile();
  const dispatch = useDispatch();
  const [selectedChannel, setSelectedChanel] = useState('');
  const affiliateConfig = useSelector(getAppConfigSelector);
  const user = useSelector(getUserSelector);
  const patientConversation = useSelector(
    getPatientConversationChannelsSelector
  );

  const affiliateChats = useMemo(() => {
    const chats = ['clinical'];
    const currentAffiliate = getItemFromLocalStorage(CURRENT_AFFILIATE);
    const affiliate = user?.patient?.affiliates.find(
      (affiliate) => affiliate.id === currentAffiliate
    );
    if (affiliate?.affiliateChatSystem) {
      if (affiliate?.affiliateChatSystemEnabledChats?.includes('billing')) {
        chats.push('billing');
      }
      if (affiliate?.affiliateChatSystemEnabledChats?.includes('support')) {
        chats.push('support');
      }
    }
    return chats;
  }, [user]);

  // CRUCIAL TO MAKE SURE THAT <App/> renders, otherwise it will crash and chats won't render
  if (!patientConversation) return null;

  return (
    <div className="groupChannelList">
      <GroupChannelList
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChannelCreated={() => {}}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChannelSelect={(channel) => {}}
        channelListQueryParams={{
          includeEmpty: true,
          customTypesFilter: affiliateChats
        }}
        disableAutoSelect
        allowProfileEdit={false}
        renderChannelPreview={({ channel }) => {
          return (
            <div
              className={classNames({
                [channel.customType]: true
              })}
            >
              <GroupChannelListItem
                channel={
                  {
                    ...channel,
                    coverUrl: affiliateConfig?.smallLogo,
                    name:
                      channelTypeMapping[channel.customType]?.name ||
                      channel.name
                  } as typeof channel
                }
                tabIndex={channelTypeMapping[channel.customType]?.index}
                onClick={() => {
                  dispatch(setChannel(channel.url));
                  dispatch(getUnreadCount());
                  setSelectedChanel(channel.customType);
                }}
                isSelected={channel.customType === selectedChannel}
                renderChannelAction={() => <></>}
              />
            </div>
          );
        }}
        renderHeader={() => (
          <GroupChannelListHeader renderRight={() => <></>} />
        )}
      />
    </div>
  );
};

export default Submenu;
